/* Keep the desktop search field connected to the theme's existing search drawer. */
(() => {
  const initializeEditorialSearch = () => {
    if (typeof PredictiveSearch === 'undefined') return;

    document.querySelectorAll('.mutuki-editorial .header.style1').forEach((header) => {
      if (header.classList.contains('editorial-search-ready')) return;

      const section = header.closest('.header-section');
      const field = header.querySelector('.editorial-header-search input[type="search"]');
      const trigger = header.querySelector('.thb-secondary-item[href*="/search"]');
      const drawer = section && section.querySelector('.thb-quick-search');
      const drawerField = drawer && drawer.querySelector('input[type="search"]');
      const results = drawer && drawer.querySelector('.thb-quick-search--results');
      if (!section || !field || !trigger || !drawerField || !results) return;

      const openExistingSearch = () => {
        if (!window.matchMedia('(min-width: 1068px)').matches) return;

        if (!section.classList.contains('search-open')) {
          // Suppress the link fallback if the original drawer listener is unavailable.
          const click = new MouseEvent('click', { bubbles: true, cancelable: true });
          click.preventDefault();
          trigger.dispatchEvent(click);
        }
        if (!section.classList.contains('search-open')) return;

        const queryChanged = drawerField.value !== field.value;
        drawerField.value = field.value;
        if (queryChanged || field.value.trim()) {
          drawerField.dispatchEvent(new Event('input', { bubbles: true }));
        }
        drawerField.focus({ preventScroll: true });
      };

      field.addEventListener('focus', openExistingSearch);
      drawerField.addEventListener('input', () => { field.value = drawerField.value; });
      header.classList.add('editorial-search-ready');
      if (document.activeElement === field) openExistingSearch();
    });
  };

  // The existing predictive search registers its drawer listeners on window load.
  if (document.readyState === 'complete') {
    initializeEditorialSearch();
  } else {
    window.addEventListener('load', initializeEditorialSearch, { once: true });
  }
})();
